import QRCode from 'qrcode';

/**
 * Generate a QR code and render it to a container
 * @param {HTMLElement} container - Container element to render the QR code into
 * @param {string} data - Data to encode in the QR code
 * @param {Object} options - Optional configuration
 * @param {number} options.width - Width in pixels (default: 200)
 * @param {string} options.darkColor - Dark color (default: #000000)
 * @param {string} options.lightColor - Light color (default: #ffffff)
 * @returns {Promise<HTMLCanvasElement>} The generated canvas element
 */
export async function generateQRCode(container, data, options = {}) {
  const {
    width = 200,
    darkColor = '#1e293b',
    lightColor = '#ffffff',
  } = options;

  // Clear container
  container.innerHTML = '';

  const canvas = document.createElement('canvas');

  await QRCode.toCanvas(canvas, data, {
    width,
    margin: 2,
    color: {
      dark: darkColor,
      light: lightColor,
    },
    errorCorrectionLevel: 'M',
  });

  container.appendChild(canvas);
  return canvas;
}

/**
 * Generate a QR code as a data URL
 * @param {string} data - Data to encode
 * @param {Object} options - Optional configuration
 * @returns {Promise<string>} Data URL of the QR code image
 */
export async function generateQRCodeDataURL(data, options = {}) {
  const {
    width = 200,
    darkColor = '#1e293b',
    lightColor = '#ffffff',
  } = options;

  return QRCode.toDataURL(data, {
    width,
    margin: 2,
    color: {
      dark: darkColor,
      light: lightColor,
    },
    errorCorrectionLevel: 'M',
  });
}
